import { render, staticRenderFns } from "./userPost.vue?vue&type=template&id=5abd10d4&scoped=true"
import script from "./userPost.vue?vue&type=script&lang=js"
export * from "./userPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abd10d4",
  null
  
)

export default component.exports